"use client";
import Navigation from "@/HomeFeatures/Navigation";
import { useRef } from "react";
import Images, { Icons } from "../assets/assets";
import PrimaryBtn from "@/components/PrimaryBtn";
import Image from "next/image";
import OutstandingMembersCard from "@/components/OutstandingMembersCard";
import Aboutsection from "./aboutsection";
import WhatShapeConstant from "./what_shape_constant";
import Industryprocess from "../solution-landing-page/IndustryProcess";
import { JourneyTimeline } from "./jurney";
import GlobalRanking from "./GlobalRanking";
import Cta from "@/HomeFeatures/Cta";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";
import OurTeam from "../our-team/page";
export default function About_Us() {
  const { handleOpenQuote } = useTheme();
  const nextSectionRef = useRef<HTMLDivElement>(null);
  return (
    <>
      <section
        className="relative h-[max-content] pb-[75px] flex header-z-index
        flex-col max-w-[100vw] overflow-hidden bg-[length:auto_100%] "
      >
        <div className="absolute inset-0 -z-10">
          <Image
            src={Images?.about_us_hero_bg}
            alt="background"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
            priority
          />
        </div>
        <div className="relative z-10 w-full">
          <div className="w-full h-full min-h-[100vh] flex flex-col pb-[100px] relative">
            <Navigation dark={false} />
            <div className="w-[calc(100vw-10%)] max-w-[2500px] mx-auto my-auto relative z-0">
              <div className="flex flex-col 2xl:flex-row items-center gap-10 justify-between py-10 lg:py-0">
                {/* Left: Based In + Image */}
                <div className="w-full 2xl:w-[700px]">
                  <div className="flex items-center text-[#636364] text-base md:text-lg mb-4">
                    <span>Based In: </span>
                    <span>&nbsp; Jaipur, India</span>
                  </div>

                  <div className="relative w-full h-[260px] sm:h-[340px] lg:h-[420px]">
                    <Image
                      src={Images?.about_us_hero}
                      alt="Konstant team"
                      fill
                      className="object-cover"
                      sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                      priority
                    />
                  </div>
                </div>

                {/* Right: Heading, subtext, CTA, members */}
                <div className="w-full 2xl:w-[calc(100%-900px)]">
                  <div className="space-y-4">
                    <h1 className="text-[clamp(1.875rem,-0.6192rem+5.1963vw,7.5rem)] leading-[1] tracking-[-0.02em]">
                      {" "}
                      Transforming Visions into
                      {/* <br className="2xl:block hidden" /> */}
                      <span className="text-[#225BD4]">
                        &nbsp;Market-Leading Solutions
                      </span>
                    </h1>
                    <p className="text-[#636364] text-lg md:text-xl max-w-[620px]">
                      We Architect Innovation That Scales with Your Goals
                    </p>
                  </div>

                  <div className="mt-6">
                    <PrimaryBtn
                      text="Talk to an Expert"
                      iconSrc={Icons?.chevron}
                      dark={false}
                      href={"/contact-us"}
                    />
                  </div>

                  <div className="mt-8">
                    <OutstandingMembersCard />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="opacity-5 hidden lg:block justify-start 
                    text-[#00040b] text-[140px] absolute z-0 bottom-0
                    font-bold clash-font capitalize leading-[140px]
                    w-[calc(100vw-10%)] max-w-[2500px] left-1/2 -translate-x-1/2
                    "
            >
              About Us
            </div>
            <div
              onClick={() =>
                nextSectionRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="justify-start text-[#00040b] 
                  absolute z-20 left-1/2 -translate-x-1/2 cursor-pointer
                  w-[calc(100vw-10%)] max-w-[2500px] text-right bottom-[20px]
                  text-lg font-normal hover:opacity-70 transition-opacity"
            >
              Scroll For More
            </div>
          </div>
        </div>
      </section>

      <div ref={nextSectionRef}>
        <Aboutsection />
      </div>

      <WhatShapeConstant />

      <Industryprocess
        mode="light"
        cta={false}
        subtitle="OUR VALUES"
        title={
          <>
            Our core purpose is to{" "}
            <span className="text-[#225BD4]">serve customers well</span>
          </>
        }
        paragraph="At Konstant, we strive to excel in the invention and development of the industry’s most advanced technologies including mobile apps, web, eCommerce, mCommerce, IoT, Wearables, AR/VR, cloud integration, cross-platform, on-demand, enterprise mobility and alike. We translate these technologies into value for our clients’ customers giving them professional and best-in-class services; thereby helping businesses throughout the world harness their full potential."
        items={[
          {
            icon: Icons?.aboutUS.Continuous_Growth,
            title: "Continuous Growth",
            description:
              "With an aim to continuously learn and evolve with every project we take on, our developers are always ready to grow with evolving market needs. Moreover, they consistently invest time in upgrading their skills through regular training and certifications. We focus on refining our expertise by turning complex challenges into impactful and scalable digital solutions. ",
          },
          {
            icon: Icons?.aboutUS.Involved_Leadership,
            title: "Involved Leadership",
            description:
              "Every project we take on is guided by experienced tech leaders and experts who set the foundation of success from day one. We assign a dedicated project manager for every project to maintain proactive communication, manage client relationships, ensure clear development direction, and align business objectives with seamless project execution.",
          },
          {
            icon: Icons?.aboutUS.Taking_Responsibility,
            title: "Taking Responsibility",
            description:
              "Our core values and work culture is backed by accountability. For every project, we take full responsibility for our actions, decisions, and outcomes to foster an environment of innovation and trust. At Konstant, we are committed to hold responsibility for work we do, ensuring expectations are met with integrity and reliability.",
          },
          {
            icon: Icons?.aboutUS.Adaptive_Partnership,
            title: "Adaptive Partnership",
            description:
              "We focus on an adaptive partnership approach to collaborate with our clients at any point of their digital transformation journey. From early-stage assessments to large-scale enterprise deployments, our developers can handle all your project needs. With flexible engagement and hiring models, our expert designers and developers can seamlessly become a part of your existing team.",
          },
          {
            icon: Icons?.aboutUS.Openness,
            title: "Openness",
            description:
              "Ensuring total transparency during development lifecycle is what defines our work values. We are committed to fostering long-lasting relationships backed by accessibility, mutual trust, and honest communication. This clarity empowers our teams to make informed decisions, take responsibility, and build long-term relationships grounded in trust.",
          },
          {
            icon: Icons?.aboutUS.AI_Driven_Agility,
            title: "AI-Driven Agility",
            description:
              "At Konstant, we bend AI-first engineering principles with our expertise to create future-ready solutions integrated with robust MLOPs frameworks and intelligent automation. Through faster iterations and continuous improvements, we respond quickly to clients’ needs and demands, helping them to stay competitive and adaptable in today’s tech landscape.",
          },
        ]}
      />

      <JourneyTimeline />
      <GlobalRanking />
      <OurTeam />
      <Cta
        title1={
          <>
            <span className="text-[#fff]">Need Project Estimation?</span>{" "}
            <br></br>
          </>
        }
        title2={
          <span className="text-[#fff]">Book a Consultation Call Today!</span>
        }
        description={
          <span className="text-[#fff]">
            Get in touch with us to accelerate your digital journey and build
            your next project.
          </span>
        }
        button={
          <PrimaryBtn
            text="Request a Quote"
            iconSrc={Icons?.chevronBlue}
            dark={true}
            onClick={() => {
              handleOpenQuote();
            }}
          />
        }
        bgImage={Images?.serviceCtaBg}
        animationShade="bg-gradient-to-t from-[#0C41B2] via-[#0C41B2]/70 to-transparent"
      />
    </>
  );
}
